import { QueryHandler } from '../../_base/actionBus/QueryHandler';
import { SessionStorage } from '../../models/session/SessionStorage';
import { PaymentService } from '../../models/payments/PaymentService';
import { GetRedepagosBarcode } from './GetRedepagosBarcode';

export class GetRedepagosBarcodeHandler implements QueryHandler<GetRedepagosBarcode, string> {
    constructor(private paymentService: PaymentService, private sessionStorage: SessionStorage) {}

    async handle(query: GetRedepagosBarcode): Promise<string> {
        const session = await this.sessionStorage.get();
        return this.paymentService.getUnitRedepagosBarcode(session.unit!.id);
    }
}
